import { IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

export const SendButton = ({
  onClick,
  disabled,
}: {
  onClick: CallableFunction;
  disabled?: boolean;
}) => {
  return (
    <IconButton
      disabled={disabled}
      sx={{
        backgroundColor: "primary.main",
        color: "white",
        ":hover": { backgroundColor: "primary.light", color: "white" },
        ":disabled": {
          backgroundColor: "grey.400",
          color: "white",
        },
      }}
      onClick={() => onClick()}
    >
      <SendIcon />
    </IconButton>
  );
};
